import { render, staticRenderFns } from "./layout-info.vue?vue&type=template&id=419a10b8"
import script from "./layout-info.vue?vue&type=script&lang=js"
export * from "./layout-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports